// ro-select.js
const Utils = RO.classes.Utils

;(() => {
    const openedClass = 'ro-select--opened'
    const optionClass = 'ro-select__option'
    const multiOptionClass = 'ro-selected-multi-option'
    const triggerSelector = '.ro-select__trigger'
    const optionsBoxSelector = '.ro-select__options-box'
    const inputSelector = '.ro-select__input'
    const simpleResultBoxSelector = '.ro-select__simple-result-box'
    const multiResultBoxSelector = '.ro-select__multi-result-box'
    const multiValueDelimiter = '|'

    const selects = document.querySelectorAll('.ro-select')
    selects.forEach(select => {
        const isMulty = select.dataset.roMulty == 'true'
        const onlyEvent = select.dataset.roOnlyEvent == 'true'
        const preventClosingOnSelection = select.dataset.roPreventClosingOnSelection == 'true'

        const trigger = select.querySelector(triggerSelector)
        const optionsBox = select.querySelector(optionsBoxSelector)
        const input = select.querySelector(inputSelector)
        const simpleResultBox = select.querySelector(simpleResultBoxSelector)
        const multiResultBox = select.querySelector(multiResultBoxSelector)

        const openEvent = new Event('open')
        const closeEvent = new Event('close')
        const changeEvent = new Event('change')

        openEvent.select = select
        openEvent.input = input
        openEvent.isMulty = isMulty
        closeEvent.select = select
        closeEvent.input = input
        closeEvent.isMulty = isMulty
        changeEvent.select = select
        changeEvent.input = input
        changeEvent.isMulty = isMulty

       let singleLockCloseByWindowClick = false

        trigger.addEventListener('click', event => {
            event.preventDefault()

            if (isOpened(select)) {
                closeSelect(select)
            } else {
                openSelect(select)
            }
        })

        optionsBox.addEventListener('click', event => {
            const { target } = event
            const option = getOption(target)
            if (!!option) {
                if (isMulty) {
                    handleMultiOption(option)
                } else {
                    handleSingleOption(option)
                }
            }
        })

        // For delete multi options
        if (multiResultBox) {
            multiResultBox.addEventListener('click', event => {
                const { target } = event
                const option = getMultiOption(target)
                if (option) {
                    deleteMultiOption(option)
                }
            })
        }

        window.addEventListener('click', event => {
            if (singleLockCloseByWindowClick) { 
                singleLockCloseByWindowClick = false
                return 
            }
            event.stopPropagation()
            if (!Utils.isSameOrChild(select, event.target)) {
                closeSelect(select)
            }
        })

        updateVisualHTML()

    
        function updateVisualHTML() {
            if (onlyEvent) { return }

            if (isMulty) {
                updateVisualHTMLMulti()
            } else {
                updateVisualHTMLSingle()
            }
        }

        function updateVisualHTMLSingle() {
            const { value } = input
            const selector = `.${optionClass}[data-ro-value="${value}"]`
            const option = optionsBox.querySelector(selector)

            if (option) {
                simpleResultBox.innerHTML = option.innerHTML
            }
        }

        function updateVisualHTMLMulti() {
            multiResultBox.innerHTML = ''
            const { value: values } = input
            const valuesArray = !!values ? values.split(multiValueDelimiter) : []

            let multiResultBoxContent = ''

            valuesArray.forEach(val => {
                const selector = `.${optionClass}[data-ro-value="${val}"]`
                const option = optionsBox.querySelector(selector)

                if (!option) {
                    return
                }

                const content = option.innerHTML
                const value = option.dataset.roValue

                multiResultBoxContent += generateSelectedMultiOption(content, value)
                option.style.display = 'none'
            })

            multiResultBox.innerHTML = multiResultBoxContent
        }

        function generateSelectedMultiOption(content, value) {
            return `
            <div class="ro-selected-multi-option custom-selected-multi-option" data-ro-value="${value}">
                <span class="custom-selected-multi-option__name ro-selected-multi-option__name">${content}</span>
                <span class="custom-selected-multi-option__delete ro-selected-multi-option__delete"></span>
            </div>
            `
        }

        function deleteMultiOption(optionFromMultiBox) {
            if (!optionFromMultiBox) { return }

            singleLockCloseByWindowClick = true

            const { roValue : valueToRemove } = optionFromMultiBox.dataset
            const values = input.value

            let valuesArray = !!values ? values.split(multiValueDelimiter) : []

            valuesArray = valuesArray.filter(el => {
                return el != valueToRemove
            })
            
            // set value
            input.value = valuesArray.join(multiValueDelimiter)

            // emit change event
            changeEvent.value = input.value
            select.dispatchEvent(changeEvent)

            // Show option in option box
            const selector = `.${optionClass}[data-ro-value="${valueToRemove}"]`
            const option = optionsBox.querySelector(selector)
            if (option) {
                option.style = ''
            }

            updateVisualHTMLMulti()
        }

        function handleSingleOption(option) {
            const { roValue: value} = option.dataset

            if (!onlyEvent) {
                input.value = value
                updateVisualHTMLSingle()
            }

            changeEvent.value = value
            select.dispatchEvent(changeEvent)

            if (!preventClosingOnSelection) {
                closeSelect()
            }
        }

        function handleMultiOption(option) {
            const { roValue: newValue} = option.dataset
            const prevValuesStr = input.value
            const prevValuesArray = !!prevValuesStr ? prevValuesStr.split(multiValueDelimiter) : []
            if (!prevValuesArray.includes(newValue)) {
                prevValuesArray.push(newValue)
            }
            input.value = prevValuesArray.join(multiValueDelimiter)

            // update visual
            updateVisualHTMLMulti()

            // emit event
            changeEvent.value = input.value
            select.dispatchEvent(changeEvent)
        }

        /**
         * 
         * @returns option from dropdown
         */
        function getOption(el) {
            return el.classList.contains(optionClass) ? el : el.closest(`.${optionClass}`)
        }

        /**
         * 
         * @returns multi option for deleting for multi select
         */
        function getMultiOption(el) {
            return el.classList.contains(multiOptionClass) ? el : el.closest(`.${multiOptionClass}`)
        }

        function isOpened() {
            return select.classList.contains(openedClass)
        }
    
        function openSelect() {
            select.classList.add(openedClass)
            select.dispatchEvent(openEvent)
        }
    
        function closeSelect() {
            if (!isOpened()) {
                return
            }

            select.classList.remove(openedClass)
            select.dispatchEvent(closeEvent)
        }
    })

    
})();